import React from 'react';

// An endless scrolling banner: two identical copies slide left by exactly one
// copy's width, then the loop restarts, so there is never a gap or a jump.
function Ticker({ message }) {
  return (
    <div className="fm-ticker" aria-hidden="true">
      <div className="fm-ticker-track">
        <span className="fm-ticker-group">{message}</span>
        <span className="fm-ticker-group">{message}</span>
      </div>
    </div>
  );
}

export default Ticker;
